import { IPageState } from '../../types/redux';

const initialState: IPageState = {
  subdomain: 'www',
  deviceType: 'desktop' as 'desktop',
};

export function pageReducer(state: IPageState = initialState) {
  return state;
}
